import './Skills.css'
import React from 'react';

const Skills = () => {
    return (
        <div className='skills'>
            <h1 className="skills-title">
                <span>Skills & experience</span>
            </h1>
            <div className='skills-grid'>
                <div className="skills-des">
                    <p><span style={{ color: '#ffb400' }}>I</span> have good experience in both front-end and and backend technology. Mainly i work with MERN stack. <br />
                        Beside Web Development I have some additional skills like graphics dedign, Blander 3d, Game Development with Unity & C#. </p>

                </div>
                <div className="skills-list">
                    <h3>Frontend:</h3>
                    <div className="skills-stack">
                        <span className="skills-item">
                            <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_960_720.png" alt="HTML" />
                            <p>HTML</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_640.png" alt="HTML" />
                            <p>CSS</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://raw.githubusercontent.com/krishaayjois21/krishaayjois21/master/assets/javascript.png" alt="JavaScript" />
                            <p>JavaScript</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://yogalayout.com/static/reactnative.4e03ea5d.png" alt="HTML" />
                            <p>React</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://www.coffeecup.com/images/software/icons/bootstrap-builder_2.5_win_en.png" alt="HTML" />
                            <p>Bootstrap</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/tailwind-css.png" alt="tailwind" />
                            <p>Tailwind</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://mui.com/static/logo.png" alt="Material UI" />
                            <p>Material UI</p>
                        </span>

                    </div>
                    <h3>Backend & Authentication:</h3>
                    <div className="skills-stack">
                        <span className="skills-item">
                            <img src="https://cdn3.iconfinder.com/data/icons/popular-services-brands/512/node-512.png" alt="node" />
                            <p>Node.js</p>
                        </span>
                        <span className="skills-item">
                            <img
                                style={{ objectFit: 'center' }}
                                src="https://spng.pngfind.com/pngs/s/136-1363736_express-js-icon-png-transparent-png.png" alt="express" />
                            <p>Express</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://w7.pngwing.com/pngs/241/983/png-transparent-mongodb-nosql-database-computer-icons-others-leaf-grass-fruit.png" alt="mongodb" />
                            <p>MongoDB</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJZSF61dO588rnQBCIXmOaSlYYi1pIBFW0npAtqGdx2PYzxA5aw4cwqxylqSdkS2Z_X5A&usqp=CAU" alt="firebase" />
                            <p>Firebase</p>
                        </span>
                    </div>
                    {/* i will add some additional skill too */}
                    <h3>Additional Skills</h3>
                    <div className="skills-stack">
                        <span className="skills-item">
                            <img src="https://i.pinimg.com/originals/2e/ce/e0/2ecee0ce92a5dcb8d77d1bb2c1a83c74.png" alt="Blender" />
                            <p>Blender 3D</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTylbFQ-RZAEz9latLujFK79CwVmZXVgIFF1dvCV055pvd2dTN0ZFNH8IfZpf_lc0cSbsY&usqp=CAU" alt="Unity" />
                            <p>Unity</p>
                        </span>
                        <span className="skills-item">
                            <img src="https://res.cloudinary.com/practicaldev/image/fetch/s--CuYrZ4Z8--/c_imagga_scale,f_auto,fl_progressive,h_1080,q_auto,w_1080/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/dflkmzecmpnkaym6l578.jpeg" alt="C#" />
                            <p>C#</p>
                        </span>
                    </div>

                </div>
            </div>


        </div >
    );
};

export default Skills;